import { render, staticRenderFns } from "./VehicleAveragePrice.vue?vue&type=template&id=ecbef54a&"
import script from "./VehicleAveragePrice.vue?vue&type=script&lang=js&"
export * from "./VehicleAveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports